// extracted by mini-css-extract-plugin
module.exports = {"container":"Table_container__1u_GE","title":"Table_title__2DnBL","italize":"Table_italize__mSAg8","export":"Table_export__20xim"};